import React from 'react';
import PropTypes from 'prop-types';
import { CivilDate } from 'tc39-proposal-temporal';
import { compareCivilDate } from '@bingads-webui-universal/temporal-utitlities';
import { SingleMonthCalendar } from '@bingads-webui-react/single-month-calendar';

export class DoubleMonthCalendar extends React.Component {
  static defaultProps = {
    minDate: undefined,
    maxDate: undefined,
    isMonthRangePicker: false,
    isAriaLabelTranslated: false,
  }

  constructor(props) {
    super(props);
    const [selectedDateRange] = this.props.selectedRanges;
    const leftNavigatedDate = props.isMonthRangePicker
      ? new CivilDate(selectedDateRange.start.year === selectedDateRange.end.year
        ? selectedDateRange.start.year - 1
        : selectedDateRange.start.year, 1, 1)
      : new CivilDate(
        selectedDateRange.end.year,
        selectedDateRange.end.month - 1,
        15
      );
    this.state = {
      leftNavigatedDate,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (nextProps.selectedRanges.length !== this.props.selectedRanges.length ||
      !nextProps.selectedRanges[0].start ||
      !this.props.selectedRanges[0].start ||
      !nextProps.selectedRanges[0].end ||
      !this.props.selectedRanges[0].end ||
      compareCivilDate(
        nextProps.selectedRanges[0].start,
        this.props.selectedRanges[0].start
      ) !== 0 ||
      compareCivilDate(nextProps.selectedRanges[0].end, this.props.selectedRanges[0].end) !== 0 ||
      (nextProps.selectedRanges.length === 2 &&
        (
          !nextProps.selectedRanges[1].start ||
          !this.props.selectedRanges[1].start ||
          !nextProps.selectedRanges[1].end ||
          !this.props.selectedRanges[1].end ||
          compareCivilDate(
            nextProps.selectedRanges[1].start,
            this.props.selectedRanges[1].start
          ) !== 0 ||
          compareCivilDate(
            nextProps.selectedRanges[1].end,
            this.props.selectedRanges[1].end
          ) !== 0)) ||
      compareCivilDate(nextProps.today, this.props.today) !== 0 ||
      nextState.leftNavigatedDate !== this.state.leftNavigatedDate
    ) {
      return true;
    }

    return false;
  }

  onNavigateStartMonthDate = (date) => {
    this.setState({
      leftNavigatedDate: date,
    });
  }
  onNavigateEndMonthDate = (date) => {
    if (this.props.isMonthRangePicker) {
      this.setState({
        leftNavigatedDate: date.plus({ years: -1 }),
      });
      return;
    }
    this.setState({
      leftNavigatedDate: date.plus({ months: -1 }),
    });
  }

  onSelectDate = (date) => {
    this.props.onSelectDateCallback(date);
  }

  render() {
    const { leftNavigatedDate } = this.state;
    const {
      minDate,
      maxDate,
      selectedRanges,
      today,
      i18n,
      isMonthRangePicker,
    } = this.props;
    return (
      <div className="double-month-calendar">
        <div className="left-calendar">
          <SingleMonthCalendar
            minDate={minDate}
            maxDate={maxDate}
            today={today}
            onSelectDate={this.onSelectDate}
            selectedRanges={selectedRanges}
            navigatedDate={leftNavigatedDate}
            onNavigateDate={this.onNavigateStartMonthDate}
            isRightNavigateVisible={false}
            i18n={i18n}
            isMonthRangePicker={isMonthRangePicker}
          />
        </div>
        <div className="divider" />
        <div className="right-calendar">
          <SingleMonthCalendar
            minDate={minDate}
            maxDate={maxDate}
            today={today}
            onSelectDate={this.onSelectDate}
            selectedRanges={selectedRanges}
            navigatedDate={isMonthRangePicker
              ? new CivilDate(leftNavigatedDate.year + 1, leftNavigatedDate.month, 1)
              : new CivilDate(leftNavigatedDate.year, leftNavigatedDate.month + 1, 15)}
            onNavigateDate={this.onNavigateEndMonthDate}
            isLeftNavigateVisible={false}
            i18n={i18n}
            isMonthRangePicker={isMonthRangePicker}
            isAriaLabelTranslated={this.props.isAriaLabelTranslated}
          />
        </div>
      </div>
    );
  }
}

DoubleMonthCalendar.propTypes = {
  minDate: PropTypes.instanceOf(CivilDate),
  maxDate: PropTypes.instanceOf(CivilDate),
  today: PropTypes.instanceOf(CivilDate).isRequired,
  selectedRanges: PropTypes.arrayOf(PropTypes.shape({
    start: PropTypes.instanceOf(CivilDate),
    end: PropTypes.instanceOf(CivilDate),
  })).isRequired,
  onSelectDateCallback: PropTypes.func.isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
    getFirstDayOfWeek: PropTypes.func.isRequired,
  }).isRequired,
  isMonthRangePicker: PropTypes.bool,
  isAriaLabelTranslated: PropTypes.bool,
};
